import { makeStyles } from "@material-ui/core";
import className from "classnames";
import {
  GOVGR_FULL_PAGE_BACKGROUND,
  GOVGR_LAYOUT_WRAPPER,
  GOVGR_LAYOUT_WRAPPER__FULL_HEIGHT,
  GOVGR_LOADER,
  GOVGR_LOADER_CONTAINER,
  GOVGR_LOADER__CIRCLE,
  GOVGR_LOADER__CIRCLE__1,
  GOVGR_LOADER__CIRCLE__2,
} from "../../conf/styles/GovGrLoader";
const useStyles = makeStyles((theme) => ({
  backgroundComponent: {
    zIndex: `${100} !important`,
    height: "100vh",
    width: "100vw",
  },
}));
const GovGrLoader = () => {
  const classes = useStyles();
  const ComponentWrapperClass = className(
    GOVGR_LAYOUT_WRAPPER,
    "w-full h-full"
  );

  const BackgroundWrapperClass = className(
    "z-50",
    "h-full  flex items-center justify-center bg-black/5",
    { "lg:w-[80vw] lg:h-[100vh]": true }
  );

  const LoaderContainerWrapperClass = className(GOVGR_LOADER_CONTAINER);

  const LoaderWrapper = className(GOVGR_LOADER);

  const LoaderCircle1Wrapper = className(
    GOVGR_LOADER__CIRCLE,
    GOVGR_LOADER__CIRCLE__1
  );

  const LoaderCircle2Wrapper = className(
    GOVGR_LOADER__CIRCLE,
    GOVGR_LOADER__CIRCLE__2
  );

  return (
    <div className={ComponentWrapperClass}>
      <div className={BackgroundWrapperClass}>
        <div className={LoaderContainerWrapperClass}>
          <svg
            className={LoaderWrapper}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
          >
            <path
              className={LoaderCircle1Wrapper}
              d="M26,99.551C26,55.478,60.246,27.5,99.85,27.5S174,55.478,174,99.551,139.455,172.5,99.85,172.5C60.273,172.473,26,143.6,26,99.551Z"
            ></path>
            <path
              className={LoaderCircle2Wrapper}
              d="M26,99.551C26,55.478,60.246,27.5,99.85,27.5S174,55.478,174,99.551,139.455,172.5,99.85,172.5C60.273,172.473,26,143.6,26,99.551Z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
  );
};
export default GovGrLoader;
